module.exports = __webpack_public_path__ + "static/media/volume-off.7dd6e6aa.svg";